import React from 'react'
import clsx from 'clsx'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  href?: string
  as?: 'button' | 'a'
  className?: string
}

function Button({
  children,
  href,
  as = 'button',
  className = '',
  type = 'button',
  disabled = false,
  ...props
}: ButtonProps) {
  const baseClass =
    'w-full sm:w-auto min-h-[48px] py-3.5 px-12 bg-gradient-to-r from-[#ffa300] to-yellow-400 text-black font-bold rounded-xl hover:scale-105 hover:shadow-lg transition-all duration-200 mt-4 sm:mt-6 text-xl flex items-center justify-center shadow-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-[#ffa300] focus-visible:ring-offset-2 disabled:opacity-60 disabled:pointer-events-none';

  if (href) {
    return (
      <a
        href={href}
        className={clsx(baseClass, className)}
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
        {...props as any}
      >
        {children}
      </a>
    )
  }
  return (
    <button
      type={type}
      className={clsx(baseClass, className)}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button 